import { io } from "socket.io-client";

let socket;

export function getSocket() {
  if (!socket) {
    socket = io("https://api.7-trade.ir", {
      transports: ["websocket", "polling"],
      // only needed if the server sets a custom path — default is "/socket.io/"
      // path: "/socket.io/",
    });
    socket.on("connect", () => console.log("CONNECTED", socket.id));
    socket.on("connect_error", (e) => console.log("ERROR", e.message));
  }
  return socket;
}
